<template>
    <aside class="c-chat" :class="{'is-open': open}">
        <section class="c-chat__messages">
            <h2 class="c-chat__messages__title c-title--border u-h3">
                {{ $t('chat.messages.title') }}
            </h2>
            <button class="c-chat__close u-color-white" :aria-label="$t('chat.close')" @click="open = false">
                <svgicon name="cross"></svgicon>
            </button>
            <ul class="c-chat__messages__list">
                <li class="c-chat__messages__item" v-for="usermessage in messages" v-bind:key="usermessage.id">
                    <h3 class="c-chat__messages__item__title">{{usermessage.Audit.CreateUser}}</h3>
                    <div class="c-chat__messages__item__body">{{usermessage.Content}}</div>
                </li>
            </ul>
        </section>
        <section class="c-chat__message">
            <h2 class="c-chat__message__title c-title--border u-h3">
                {{ $t('chat.message.title', {'name': receiver}) }}
            </h2>

            <textarea v-model="message.input"
                      @keydown="messageHandler"
                      rows="5" placeholder=""
                      class="c-form-element c-input c-textarea">

            </textarea>

            <label v-if="isSalesman" class="c-checkbox c-chat__message__notify">
                <input v-model="message.notifyClient"
                       class="c-checkbox__input"
                       type="checkbox"
                       :true-value="true"
                       :false-value="false">
                <span class="c-checkbox__label">
                {{ $t('chat.message.notify_client') }}
                </span>
            </label>

            <button v-on:click="SendChatMessage" class="c-button c-button--alpha c-chat__message__submit">
                {{ $t('chat.message.submit') }}
            </button>

        </section>
        <button @click="open = true" class="c-chat__open" :class="{'is-open': open}">
            {{ $t('chat.open') }} {{ receiver }}
            <img v-if="salesmanPhoto" :src="salesmanPhoto" width="100" />
            <img v-else src="@/assets/images/no_profile.png" width="100" />
            <span v-show="unreadMessages" :class="{'count__unread': true, 'animate-count': animate}">{{ unreadMessages }} </span>
        </button>
    </aside>
</template>

<script>

    import '@/assets/scripts/jquery-3.3.1.min.js'
    import '@/assets/scripts/jquery.signalR-2.2.2.min.js'


    export default {
        mounted () {
            //  (function ($, window, undefined) {
            // Set local variables

            var baseUrl = window.app.config.baseUrl;
            var url = baseUrl.substring(0, baseUrl.length - 4);
            let chatServerurl = url + "signalr";
            this.accessToken = localStorage.getItem('ra_token');
            this.preOrderId = this.$route.params.id;

            /* ----- Create Chathub Proxy ----- */
            // Check if SignalR is loaded correctly;
            if (typeof ($.signalR) !== "function") console.log("SignalR: SignalR is not loaded.");

            let signalR = $.signalR;

            // Function to make the client callbacks
            function makeProxyCallback (hub, callback) {
                return function () {
                    callback.apply(hub, $.makeArray(arguments));
                };
            }

            function registerHubProxies (instance, shouldSubscribe) {
                let key, hub, memberKey, memberValue, subscriptionMethod;

                for (key in instance) {

                    if (instance.hasOwnProperty(key)) {
                        hub = instance[key];

                        if (!(hub.hubName)) continue;

                        if (shouldSubscribe) {
                            subscriptionMethod = hub.on;
                        } else {
                            subscriptionMethod = hub.off;
                        }

                        for (memberKey in hub.client) {
                            if (hub.client.hasOwnProperty(memberKey)) {

                                memberValue = hub.client[memberKey];

                                if (!$.isFunction(memberValue)) continue;

                                subscriptionMethod.call(hub, memberKey, makeProxyCallback(hub, memberValue));
                            }
                        }
                    }
                }
            }

            $.hubConnection.prototype.createHubProxies = function () {
                let proxies = {};
                this.starting(function () {
                    registerHubProxies(proxies, true);
                    this._registerSubscribedHubs();
                }).disconnected(function () {
                    registerHubProxies(proxies, false);
                });

                proxies['chatHub'] = this.createHubProxy('chatHub');
                proxies['chatHub'].client = {};
                proxies['chatHub'].server = {
                    initializeChat: function (preOrderId) {
                        return proxies['chatHub'].invoke.apply(proxies['chatHub'], $.merge(["InitializeChat"], $.makeArray(arguments)));
                    },

                    openChat: function (preOrderId) {
                        return proxies['chatHub'].invoke.apply(proxies['chatHub'], $.merge(["OpenChat"], $.makeArray(arguments)));
                    },

                    read: function (preOrderId) {
                        return proxies['chatHub'].invoke.apply(proxies['chatHub'], $.merge(["Read"], $.makeArray(arguments)));
                    },

                    send: function (preOrderId, message) {
                        return proxies['chatHub'].invoke.apply(proxies['chatHub'], $.merge(["Send"], $.makeArray(arguments)));
                    }
                };

                return proxies;
            };

            signalR.hub = $.hubConnection(chatServerurl, {useDefaultPath: false});
            $.extend(signalR, signalR.hub.createHubProxies());

            // }(window.jQuery, window));

        },
        props: {
            receiver: String,
            salesmanPhoto: String,
            unreadMessages: Number
        },
        data () {
            return {
                connectionStarted: false,
                chatServerurl: String,
                accessToken: String,
                preOrderId: String,
                SendChatMessage: Function,
                animate: true,
                open: this.getOpenFormLocalStorage(),
                name: "Ja bos",
                messages: [],
                message: {
                    input: '',
                    notifyClient: false,
                    mail: '',
                }
            }
        },
        watch: {
            open: function (val) {
                if (!this.connectionStarted) this.openChat();
                if (val) this.updateUnreadMessages(0)
                return localStorage.setItem('chat-open', val)
            },
            messages() {
                if (!this.open) {
                    this.updateUnreadMessages(this.unreadMessages+1)
                }
            }
        },
        computed: {
            isSalesman () {
                return this.$store.getters.isSalesman;
            },
        },
        updated() {
            this.scrollToEnd();
        },
        methods: {
            messageHandler(e) {
                if (e.keyCode === 13 && !e.shiftKey) {
                    e.preventDefault();
                    if (this.message.input !== '') {
                        this.SendChatMessage();
                    }
                }
            },
            scrollToEnd: function() {
                let container = this.$el.querySelector(".c-chat__messages__list");
                container.scrollTop = container.scrollHeight;
            },
            getOpenFormLocalStorage () {
                return localStorage.getItem('chat-open') === true;
            },
            openChat () {
                $.connection.hub.qs = {'access_token': this.accessToken};
                let chat = $.connection.chatHub;
                let scope = this;

                // Bind functions to client Callbacks
                chat.client.initializeChat = this.initializeChatCallBack;
                chat.client.broadcastMessage = this.broadcastMessage;

                $.connection.hub.start().done(function () {
                    scope.connectionStarted = true;

                    chat.server.initializeChat(scope.preOrderId);

                    chat.server.openChat(scope.preOrderId).done(function (messages) {
                        scope.renderChatMessages(messages);
                        chat.server.read(scope.preOrderId);
                    });

                    scope.SendChatMessage = function () {
                        chat.server.send(scope.preOrderId, {
                            "content": scope.message.input,
                            "SendEmailToCustomer": scope.message.notifyClient
                        });
                    }

                }).fail(function () {
                    console.log("Connection could not be made, please contact your administrator");
                });
            },
            /* --- Callbacks ---*/
            initializeChatCallBack (salesmanName, salesmanPhoto, unreadMessages) {
            },
            broadcastMessage (rcvdMessage) {
                console.log(rcvdMessage);
                this.message.input = "";
                this.message.notifyClient = false;
                this.messages.push(rcvdMessage);
            },
            /* --- End Callbacks ---*/
            renderChatMessages (messages) {
                this.messages = messages;
            },
            updateUnreadMessages(value) {
                this.toggleAnimate();
                this.$emit('update-unread', value);
            },
            toggleAnimate() {
                let self = this;
                this.animate = false;

                setTimeout(function() {
                    self.animate = true;
                }, 300);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/chat/Chatbox.vue